import eventBus from '../eventBus';

export default {
  methods: {
    onGoToStep(payload) {
      if ('hasValidation' in this && this.hasValidation) {
        this.validate().then(() => {
          this.$_goToStep(payload);
        }).catch(() => {
        });
      } else {
        this.$_goToStep(payload);
      }
    },

    $_goToStep(payload) {
      if ('path' in payload) {
        this.$router.push(payload.path);
      }
    },
  },

  created() {
    eventBus.$on('go-to-step', this.onGoToStep);
  },

  beforeDestroy() {
    eventBus.$off('go-to-step', this.onGoToStep);
  },
};



// WEBPACK FOOTER //
// ./src/mixins/step.js